exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".complete-filter .input-with-date,.complete-filter .input-with-date input{width:100%}.complete-filter button{width:auto;margin-top:20px;padding:0 20px}.price-value{display:block;margin-bottom:20px;font-weight:600;text-transform:capitalize;color:#444d58;font-size:16px;margin-left:6px;margin-top:0}.price-value span{color:#e7505a}.btn-all-excel{cursor:pointer;display:inline-block;padding:8px 10px;background-color:#00a651;color:#fff;margin-bottom:20px;border-radius:4px!important;float:right;font-weight:600;margin-top:0;border:none}.btn-all-excel,.btn-all-excel i{margin-left:5px}.btn-all-excel:hover{color:#fff;background-color:#008d45}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59066d90","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/allCompany/listChurnsOld.vue
// module id = 1182
// module chunks = 0